import { ROLE_LABEL, ROLE_STYLE } from "@/lib/constants";

export const RoleBadge = ({ role, testId, regionAdmin }) => (
  <span className="inline-flex items-center gap-1">
  <span
    data-testid={testId}
    className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${ROLE_STYLE[role] || "bg-muted"}`}
  >
    {ROLE_LABEL[role] || role}
  </span>
  {regionAdmin && <span className="whitespace-nowrap rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-900" data-testid={testId ? `${testId}-region-admin` : undefined}>Region Admin</span>}
  </span>
);

const STATUS_STYLE = {
  published: "bg-emerald-50 text-emerald-700 border-emerald-200",
  draft: "bg-amber-50 text-amber-700 border-amber-200",
  archived: "bg-zinc-100 text-zinc-500 border-zinc-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold capitalize ${STATUS_STYLE[status] || ""}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {status}
  </span>
);

export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
    <div className="max-w-2xl">
      {eyebrow && <span className="eyebrow text-lasso-deep">{eyebrow}</span>}
      <h1 className="mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl" data-testid="page-title">
        {title}
      </h1>
      {description && <p className="mt-3 text-sm text-muted-foreground sm:text-base">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
  </div>
);

export const EmptyState = ({ title, description, testId = "empty-state" }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-lasso-line bg-white px-6 py-16 text-center">
    <p className="font-display text-base font-semibold">{title}</p>
    {description && <p className="mt-2 text-sm text-muted-foreground">{description}</p>}
  </div>
);
